import React from 'react';
import Splash_Signin from '../commons/splash_signin';
import {IndexLink, Link} from 'react-router';
var querystring = require('querystring');

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';
import Footer2Component from "../commons/footer2";

export default class EnterprisePage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            first_name_lead: '',
            last_name_lead: '',
            email_name_lead: '',
            title_name_lead: '',
            part_name_lead: '',
            subscrible_name_lead: 0,
            errors: {},
            menuShow: false,
        }
    }

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        window.location = link;
    }

    render() {

		if (isMobile) {
            return (
                <div className="companies_boxx" id="v-enterprise_mobile">
                    <div className={"block-001 row mr0"}>
                        <Link to="/"><img className={"img_logo"} alt="mini-internships" src="/static/img/homeimg/home2/m-logo.png"/></Link>
                        <div className={"mobile-dropdown"}>
                            <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                <title>Menu</title>
                                <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                            </svg>
                            <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
                                <li onClick={() => this.mouseLinkClick("/signup")}><span>Join</span></li>
                                <li onClick={() => this.mouseLinkClick("/signin")}><span>Sign in</span></li>
                            </ul>
                        </div>
                        <div className="col-xs-12 text-center t-content">
                            <h2>Outsource work to<br/>top college talent to<br/>grow your business</h2>
                            <p>Versity Enterprise can help you take advantage of the latest innovations and leverage flexible, scalable and cost-effective options.</p>
                            <a className="btn" href="/signup">Get Started</a>
                        </div>
                        <img className="img_logo_bg cls-image-line" src={"/static/img/homeimg/home2/img-01-line.png"}/>
                    </div>
                    <div className="row main-content popular-services">
                        <span className="top-title">Popular Projects</span>
                        <div className="s-30">&nbsp;</div>
                        <div className="div-block-10">
                            <ul className="pills-list__list pills-list--mobile">
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Penetration Testing
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Bug Bounty
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Vulnerability Disclosure
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Attack Service Management
                                    </a>
                                </li>
                            </ul>
                            <a href="/projects/browse"
                               className="pills-list__see-more">
                                See all projects
                            </a>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content how-work">
                        <span className="top-title">How it works</span>
                        <div className="s-30">&nbsp;</div>
                        <div className="div-block-10">
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-1">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 1</span>
                                    <div className="content">
                                        Post a project for your business that you want one or more students to complete.
                                    </div>
                                </div>
                            </div>
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-2">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 2</span>
                                    <div className="content">
                                        Have a dedicated Versity project manager<br/>
                                        find the students that match the project.
                                    </div>
                                </div>
                            </div>
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-3">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 3</span>
                                    <div className="content">
                                        Tasks assigned and overseen <br/>by project manager to students.
                                    </div>
                                </div>
                            </div>
                            <div className="step col-xs-12 content">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-4">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <div className="width-full">
                                    <span className="title">Step 4</span>
                                    <div className="content">
                                        Receive work and pay students within our compliant payment system.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content logos-wrapper">
                        <div className="logos">
                            <div className="logo logo-1">&nbsp;</div>
                            <div className="logo logo-2">&nbsp;</div>
                            <div className="logo logo-3">&nbsp;</div>
                            <div className="logo logo-4">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-testimonies">
                        <div className="testimonies">
                            <div className="mask w-slider-mask" id="w-slider-mask-0">
                                <div className="slider-testimony-box w-slide" aria-label="2 of 3" role="group">
                                    <div className="testimony-wrapper">
                                        <div className="testimony-text">
                                            <img src="/static/img/homeimg/companies/img-quote.png" alt="" className="image-8"/>
                                            <div className="s-20 _w-30">&nbsp;</div>
                                            <p className="p-regular text-left">Versity projects are a great way for students to showcase their abilities, skills and creative ideas through innovative projects hosted by the employer. This is definitely the way of the future </p>
                                        </div>
                                        <div className="_w-30 s-30">&nbsp;</div>
                                        <div className="testimony-person width-full">
                                            <div className="avatar avatar-square company-logo logo-company-2">&nbsp;</div>
                                            <div className="s-20">&nbsp;</div>
                                            <div className="testimony-name">
                                                <div className="h5-medium dark-gray">Josue Sejour</div>
                                                <div className="p-regular "><em>Founder<br/></em>Sejour Group</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-benefits">
                        <div className="benefits">
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Control Capital Costs</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Increase Efficiency</div>
                                </div>
                            </div>
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Focus On Core Areas</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Shape Our Future Workforce</div>
                                </div>
                            </div>
                            <div className="w-layout-grid grid-11">&nbsp;</div>
                        </div>
                    </div>
                    <div className="logos-wrapper-new press-logos">
                        <div className="logos logos-news">
                            <div className="logo logo-press-1">&nbsp;</div>
                            <div className="logo logo-press-2">&nbsp;</div>
                            <div className="logo logo-press-3">&nbsp;</div>
                        </div>
                    </div>
                    <div className="row any-question mr0">
                        <div className="main-content">
                            <span className="top-title">Any questions? We are here to help</span>
                            <div className="div-block-101">
                                <div className="row pd0">
                                    <div className="col-xs-12 content">
                                        <span className="title">What is a project?</span>
                                        <div className="content">
                                            Projects are short-term, professional assignments that are similar to those given to new hires. These projects enable students to demonstrate skills, explore career paths, and build their networks as they seek the right full-time role. Unlike traditional internships, projects can take place year-round, and are due between one week and three months after kick-off. Projects are used by companies ranging from those in the Fortune 100 to emerging start-ups, and go across departments including sales, marketing, technology, HR, and finance.
                                        </div>
                                    </div>
                                    <div className="col-xs-12 content">
                                        <span className="title">How does this differ from an internship?</span>
                                        <div className="content">
                                            Versity is different than an internship platform in three main respects: 1) nearly all projects are virtual; 2) student's work is project-based; and 3) Internship engagements have a much more significant commitment with limited flexibility. Internships tend to last least weeks, are timed around the academic calendar, and require significant oversight to plan and manage. Since each student is expected to have the expertise to successfully complete the projects on their own, clients do not need to provide the support typical for an intern.
                                        </div>
                                    </div>
                                </div>
                                <div className="row pd0">
                                    <div className="col-xs-12 content">
                                        <span className="title">Can I hire the students after working with them?</span>
                                        <div className="content">
                                            Absolutely. Most students are enrolled in an academic program, and will be seeking either post-graduation employment or summer positions. You can reach out to any student you worked with who you were impressed by with job opportunities.
                                        </div>
                                    </div>
                                    <div className="col-xs-12 content">
                                        <span className="title">Who at the company engages and works with Versity?</span>
                                        <div className="content">
                                            Versity works directly with hiring managers across departments as well as human resources for company-wide campus recruiting programs. Many department heads use Versity to get work done on-demand while building a talent pipeline for sales, marketing, finance, operations, and just about every other department. Furthermore, since the students are highly skilled and have the experience or completed the prerequisite coursework to prepare them to execute these projects, companies do not need to provide managerial oversight or control.
                                        </div>
                                    </div>
                                </div>
                                <div className="row pd0">
                                    <div className="col-xs-12 content">
                                        <span className="title">How does the payment process work?</span>
                                        <div className="content">
                                            No payment is required to post a project or evaluate students. Payment is made to Versity only at the time the engagement begins (i.e. the specific student is selected by the client). Versity holds these funds in escrow until the completion of the project is approved by the client. Payment for this business service can be made via credit card, electronic bank transfer, or check. We are also willing to work directly with our clients if any other methods are preferred.
                                        </div>
                                    </div>
                                    <div className="col-xs-12 content">
                                        <span className="title">Does a student receive any feedback?</span>
                                        <div className="content">
                                            Upon completion of the project, the company has the opportunity to provide feedback. The review of the student includes an overall rating along with an evaluation of the performance in five specific areas: timeliness, communication, quality, presentation, and skill level. In addition, companies can offer confidential feedback directly to the student, providing professional development similar to what an individual might receive from a mentor.
                                        </div>
                                    </div>
                                </div>
                                <div className="t-footer">
                                    <div className="content">
                                        <a className="btn" href="/signup">Get Started</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer2Component isSlash={true}/>
                </div>
            )
        }

        return (
            <div id="splash" className="v-home">
                <header>
                    <div className="header">
                        <div className="splash_logo"><Link to="/"><img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/></Link></div>
                        <Splash_Signin type="0" openDialog={this.props.openDialog} url="/code/apis.php"/>
                    </div>
                </header>
                <div id="v-enterprise" className="splash_wrapper companies_boxx">
                    <div className="splash-block row pd0">
                        <div className="row tops">
                            <div className="t-header">
                                <div className="content">
                                    <h1 className="title">Outsource work to top college talent to grow your business</h1>
                                    <span className="sub-title">
                                    Versity Enterprise can help you take advantage of the latest innovations and leverage flexible, scalable and cost-effective options.
                                </span>
                                </div>
                            </div>
                            <div className="t-footer">
                                <div className="content">
                                    <a className="btn" href="/signup">Get Started</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row main-content popular-services">
                        <span className="top-title">Popular Projects</span>
                        <div className="s-30">&nbsp;</div>
                        <div className="div-block-10">
                            <ul className="pills-list__list">
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Penetration Testing
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Bug Bounty
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Vulnerability Disclosure
                                    </a>
                                </li>
                                <li className="pills-list__item">
                                    <a href="#" className="pill pill--filled">
                                        Attack Service Management
                                    </a>
                                </li>
                            </ul>
                            <a href="/projects/browse"
                               className="pills-list__see-more">
                                See all projects
                            </a>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content how-work">
                        <span className="top-title">How it works</span>
                        <div className="s-30">&nbsp;</div>
                        <div className="div-block-10">
                            <div className="to-do-left col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-1">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 1</span>
                                <div className="content">
                                    Post a project for your business that you want one or more students to complete.
                                </div>
                            </div>
                            <div className="to-do-middle col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-2">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 2</span>
                                <div className="content">
                                    Have a dedicated Versity project manager find the students that match the project.
                                </div>
                            </div>
                            <div className="to-do-right col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-3">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 3</span>
                                <div className="content">
                                    Tasks assigned and overseen by project manager to students.
                                </div>
                            </div>
                            <div className="to-do-right col-xs-3 content pd0">
                                <div className="content-center step-icon-vertical">
                                    <div className="step-line step-line-vertical"></div>
                                    <div className="icon-med-wrapper">
                                        <div className="circle circle-4">&nbsp;</div>
                                    </div>
                                    <div className="step-line step-line-transparent step-line-vertical"></div>
                                </div>
                                <div className="s-30">&nbsp;</div>
                                <span className="title">Step 4</span>
                                <div className="content">
                                    Receive work and pay students within our compliant payment system.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="row main-content logos-wrapper">
                        <div className="logos">
                            <div className="logo logo-1">&nbsp;</div>
                            <div className="logo logo-2">&nbsp;</div>
                            <div className="logo logo-3">&nbsp;</div>
                            <div className="logo logo-4">&nbsp;</div>
                            <div className="logo logo-5">&nbsp;</div>
                            <div className="logo logo-6">&nbsp;</div>
                            <div className="logo logo-7">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-testimonies">
                        <div className="testimonies">
                            <div className="mask w-slider-mask" id="w-slider-mask-0">
                                <div className="slider-testimony-box w-slide" aria-label="2 of 3" role="group">
                                <div className="testimony-wrapper">
                                    <div className="testimony-person width-full">
                                        <div className="avatar avatar-square company-logo logo-company-2">&nbsp;</div>
                                        <div className="s-20">&nbsp;</div>
                                        <div className="testimony-name">
                                            <div className="h5-medium dark-gray">Josue Sejour</div>
                                            <div className="p-regular "><em>Founder<br/></em>Sejour Group</div>
                                        </div>
                                    </div>
                                    <div className="_w-30 s-30">&nbsp;</div>
                                    <div className="testimony-text">
                                        <img src="/static/img/homeimg/companies/img-quote.png" alt="" className="image-8"/>
                                        <div className="s-20 _w-30">&nbsp;</div>
                                        <p className="p-regular text-left">Versity projects are a great way for students to showcase their abilities, skills and creative ideas through innovative projects hosted by the employer. This is definitely the way of the future </p>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row main-content wrapper-benefits">
                        <div className="benefits">
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Control Capital Costs</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Increase Efficiency</div>
                                </div>
                            </div>
                            <div className="perks-wrapper">
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Focus On Core Areas</div>
                                </div>
                                <div className="s-10">&nbsp;</div>
                                <div className="perk-item">
                                    <div className="glyphicon glyphicon-ok icon-check"></div>
                                    <div className="_w-10">&nbsp;</div>
                                    <div className="h5-light">Shape Our Future Workforce</div>
                                </div>
                            </div>
                            <div className="w-layout-grid grid-11">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-100 s-40">&nbsp;</div>
                    <div className="logos-wrapper-new press-logos">
                        <div className="logos logos-news">
                            <div className="logo logo-press-1">&nbsp;</div>
                            <div className="logo logo-press-2">&nbsp;</div>
                            <div className="logo logo-press-3">&nbsp;</div>
                            <div className="logo logo-press-4">&nbsp;</div>
                        </div>
                    </div>
                    <div className="s-60 s-40">&nbsp;</div>
                    <div className="row any-question">
                        <div className="s-60 s-40">&nbsp;</div>
                        <div className="main-content">
                            <span className="top-title">Any questions? We are here to help</span>
                            <div className="s-30">&nbsp;</div>
                            <div className="div-block-101">
                                <div className="row">
                                    <div className="col-xs-6 content">
                                        <span className="title">What is a project?</span>
                                        <div className="content">
                                            Projects are short-term, professional assignments that are similar to those given to new hires. These projects enable students to demonstrate skills, explore career paths, and build their networks as they seek the right full-time role. Unlike traditional internships, projects can take place year-round, and are due between one week and three months after kick-off. Projects are used by companies ranging from those in the Fortune 100 to emerging start-ups, and go across departments including sales, marketing, technology, HR, and finance.
                                        </div>
                                    </div>
                                    <div className="col-xs-6 content">
                                        <span className="title">How does this differ from an internship?</span>
                                        <div className="content">
                                            Versity is different than an internship platform in three main respects: 1) nearly all projects are virtual; 2) student's work is project-based; and 3) Internship engagements have a much more significant commitment with limited flexibility. Internships tend to last least weeks, are timed around the academic calendar, and require significant oversight to plan and manage. Since each student is expected to have the expertise to successfully complete the projects on their own, clients do not need to provide the support typical for an intern.
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6 content">
                                        <span className="title">Can I hire the students after working with them?</span>
                                        <div className="content">
                                            Absolutely. Most students are enrolled in an academic program, and will be seeking either post-graduation employment or summer positions. You can reach out to any student you worked with who you were impressed by with job opportunities.
                                        </div>
                                    </div>
                                    <div className="col-xs-6 content">
                                        <span className="title">Who at the company engages and works with Versity?</span>
                                        <div className="content">
                                            Versity works directly with hiring managers across departments as well as human resources for company-wide campus recruiting programs. Many department heads use Versity to get work done on-demand while building a talent pipeline for sales, marketing, finance, operations, and just about every other department. Furthermore, since the students are highly skilled and have the experience or completed the prerequisite coursework to prepare them to execute these projects, companies do not need to provide managerial oversight or control.
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-6 content">
                                        <span className="title">How does the payment process work?</span>
                                        <div className="content">
                                            No payment is required to post a project or evaluate students. Payment is made to Versity only at the time the engagement begins (i.e. the specific student is selected by the client). Versity holds these funds in escrow until the completion of the project is approved by the client. Payment for this business service can be made via credit card, electronic bank transfer, or check. We are also willing to work directly with our clients if any other methods are preferred.
                                        </div>
                                    </div>
                                    <div className="col-xs-6 content">
                                        <span className="title">Does a student receive any feedback?</span>
                                        <div className="content">
                                            Upon completion of the project, the company has the opportunity to provide feedback. The review of the student includes an overall rating along with an evaluation of the performance in five specific areas: timeliness, communication, quality, presentation, and skill level. In addition, companies can offer confidential feedback directly to the student, providing professional development similar to what an individual might receive from a mentor.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="s-60 s-40">&nbsp;</div>
                    </div>
                </div>
                <Footer2Component isSlash={true}/>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/enterprise.js
 **/